import useBaseLoadById from "../useBaseLoadById";
import { Role, GetRoleByIdRequest, GetRoleByIdResponse } from "src/api/Tmd.dtos";
import type { SWRConfiguration } from "swr";

const useRoleById = (
    id?: number | null | undefined,
    configuration?: SWRConfiguration<GetRoleByIdResponse, GetRoleByIdResponse> | null | undefined,
) =>
    useBaseLoadById<Role, GetRoleByIdResponse, GetRoleByIdRequest>(
        GetRoleByIdRequest,
        id,
        configuration,
    );

export default useRoleById;
